import { ACTIONS } from '../../Models/ENUM';
import CONQUER from '../CONQUER';
import Storage from '../UTILS/Storage';
import User from './User';
import LOG, { log } from '../../UTIL/LOG';
import AvatarInstance from '../AVATAR/AvatarInstance';
import DATE from '../../UTIL/DATE';
import RANDOM from '../../UTIL/RANDOM';
import USERNAME from '../../Core/USER/USERNAME';
import { param } from 'jquery';
import { connected } from 'process';

class Auth 
{
    private authTokenKey = 'CONQUERAUTHTOKEN'
    private conquer: CONQUER;

    public constructor(instance:CONQUER) 
    {
        this.conquer = instance;
    }

    public async init( disableAutoAuth?:boolean ) : Promise<any> 
    {
        // if (typeof this.conquer.User != 'undefined' && 
        // (
        //     this.conquer.User!.type == 'FACEBOOK' || 
            // this.conquer.User!.type == 'DISCORD' || 
            // this.conquer.User!.type == 'GOOGLE' || 
            // this.conquer.User!.type == 'TWITTER' || 
            // this.conquer.User!.type == 'SNAPCHAT' || 
        //     this.conquer.User!.type == 'WALLET' ||
        //     typeof this.conquer.User!.token != 'undefined'
        // )
        // ) 
        // console.log(`[Conquer Auth] init conquer.User: ${JSON.stringify(this.conquer.User)}`);

        if( !disableAutoAuth ) await this.tryToPreAuth();

        return Promise.resolve();
    }

    private async tryToPreAuth(){

        if( typeof this.conquer.User == 'string' ){

            this.conquer.User = {
                username: this.conquer.User,
                type: 'GUEST'
            };

            await this.get( this.conquer.User );

            return;

        }

        let authToken = this.conquer.Storage.get(this.authTokenKey);
        if( authToken ) await this.get( { token: authToken, type: 'USERNAME' })

        if( !this.conquer.User || !this.conquer.User.token ) await this.guest();

    }
 
    public async set( params:any ) : Promise<any> 
    {
        params.password += "";
        params.type = "USERNAME";

        // params: { username: string, password: string, email: string, firstName: string, lastName: string }
 
        let response = await this.conquer.do( ACTIONS.AUTH_SET, params );

        if( !response.error ) await this.get( { username: params.username, password: params.password, type:"USERNAME" } );
  
        return Promise.resolve(response);
    }
 
    public async verify( params : { username: string, code: string } ) : Promise<{success:boolean, message?:string}> 
    {
 
        let response = await this.conquer.do( ACTIONS.AUTH_VERIFY, {
            username: params.username,
            code: params.code
        });
 
        // this.conquer.Storage.setAccount( response );
        // this.conquer.Avatars.init();
        // this.conquer.Analytics.onEntryPoint();
        await this.tryToPreAuth();
        return Promise.resolve(response);
    }
 
    public async resend( params : { username: string } ) : Promise<{success:boolean, message?:string}> 
    {
        let response = await this.conquer.do( ACTIONS.AUTH_RESEND_VERIFY, {
            username: params.username
        } );  
        return Promise.resolve(response);
    }

    //No longer using the success/message structure
    public async resendResetKey( vars: {email: string} ) : Promise<{success:boolean, message?:string}> 
    {
        let response = await this.conquer.do( ACTIONS.AUTH_RESEND_RESETKEY, vars );  
        return Promise.resolve(response);
    }

    public async sendResetPassword( params : { email: string } ) : Promise<{success:boolean, message?:string, resetKey?:string}> 
    {
        let response = await this.conquer.do( ACTIONS.AUTH_RESET_PASSWORD, params );  
        return Promise.resolve(response);
    }

    public async changePassword( params : { email: string, password: string, resetKey: string } ) : Promise<{success:boolean, message?:string}> 
    {
        let response = await this.conquer.do( ACTIONS.AUTH_CHANGE_PASSWORD, {
            email: params.email,
            password: params.password,
            resetKey: params.resetKey
        } );  
        return Promise.resolve(response);
    }

    public async logout()
    {
        if (typeof this.conquer.User != 'undefined' && this.conquer.User.type == 'FACEBOOK') {
            await new Promise<void>((resolve, reject) => {
                FB.logout((response:fb.StatusResponse) => {
                    resolve();
                });
            });
        }
        this.conquer.Storage.remove(this.authTokenKey);
        await this.guest();

        return Promise.resolve();
    }

    public async guest() 
    {
        // await this.logout();
        this.conquer.User! = {
            type: 'GUEST',
            username: "Guest_" + DATE.now() + RANDOM.value(1000),
            firstName: 'GUEST',
            lastName: '',
        }; 
        // console.log(`[Conquer Auth] guest conquer.User: ${JSON.stringify(this.conquer.User)}`);
        let response = await this.get( this.conquer.User );
        return Promise.resolve(response);
    }

    public async admin() 
    {
        this.conquer.User!.type = 'ADMIN'; 
        let response = await this.get( this.conquer.User );
        return Promise.resolve(response);
    }

    public async get( vars?: any ): Promise<any> 
    {
        log("Auth get");
       // if( !vars ) vars = this.conquer.User;

    //    log("Auth vars", vars );
        if( vars && !vars.type && vars.password ) vars.type = "USERNAME";
 
        let response: any = await this.conquer.do( ACTIONS.AUTH_GET, vars );

    //    log("Auth response", response );

        if( Object.keys(response).length == 0 ) response = {error: true};
        if( response.error ) return Promise.resolve( response );

        // if( response.type != 'GUEST' ) response.isVerified = true;

        this.conquer.User = response;

      //  log("User", this.conquer.User );
  
        this.conquer.Avatars.init();

        this.conquer.Friends.get( true );
        this.conquer.Bots.get();

        this.conquer.Analytics.onEntryPoint();

        if( response.token ) this.conquer.Storage.set( this.authTokenKey, response.token );
        else this.conquer.Storage.remove( this.authTokenKey );
 
        this.conquer.Signal.set( "AUTH:onLogin" );
 
        return Promise.resolve( this.conquer.User );
    }

    public async getProxy(): Promise<any> 
    {
        let response : any = await this.conquer.do( ACTIONS.USERNAME_PROXY_GET, { usernameID:this.conquer.User.usernameID } );
        return Promise.resolve( response );
    }



            /*
            "id": "GAT5irLOPebfbol3QXww2WL1Ja62" = username
            "username": "SingingCheese.TLNU" = firstName 

            username = "CG_"+ vars.id,
            firstName = vars.username
            type    = "CrazyGames"
           
        */

 
};


export default Auth;